export default "__VITE_ASSET__7ea4c6f4__"